import $http from '../../axios'

export default {
    async checkMetaWhatsappStatus({ commit }) {
        try {
            const response = await $http.get('/api/meta-whatsapp/status')
            if (response.data.data && response.data.data.connected) {
                commit('SET_META_WHATSAPP_AUTH', response.data.data)
            } else {
                commit('SET_META_WHATSAPP_AUTH', null)
            }
        } catch (error) {
            commit('SET_META_WHATSAPP_AUTH', null)
        }
    },

    async connectMetaWhatsapp({ commit }, payload) {
        commit('SET_META_WHATSAPP_CONNECTING', true)
        commit('SET_META_WHATSAPP_ERROR', null)
        try {
            const response = await $http.post('/api/meta-whatsapp/connect', payload)
            commit('SET_META_WHATSAPP_AUTH', response.data.data)
            return response.data.data
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message)
                ? error.response.data.message
                : 'Error conectando Meta WhatsApp'
            commit('SET_META_WHATSAPP_ERROR', message)
            throw error
        } finally {
            commit('SET_META_WHATSAPP_CONNECTING', false)
        }
    },

    async disconnectMetaWhatsapp({ commit }) {
        try {
            await $http.delete('/api/meta-whatsapp/disconnect')
            commit('SET_META_WHATSAPP_AUTH', null)
        } catch (error) {
            console.error('Error desconectando Meta WhatsApp', error)
        }
    },
}


// WEBPACK FOOTER //
// ./src/modules/metaWhatsappApi/actions.js